var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('StyledDiv',{staticClass:"exampleForCathy"},[_c('NavBar'),_c('Splash'),_c('InfoGraphic'),_c('TedTalkLink'),_c('Features'),_c('Bottom')],1)}
var staticRenderFns = []

export { render, staticRenderFns }